module.exports = __webpack_public_path__ + "img/olc-screen-olc-4.32c3040a.jpg";